import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { StandaloneModule } from './standalone.module';
import { UserManagementComponent } from '../components/ehr/user-management/user-management.component';
import { UserManagementNewComponent } from '../components/ehr/user-management/user-management-new/user-management-new.component';
import { UserManagementEditComponent } from '../components/ehr/user-management/user-management-edit/user-management-edit.component';

@NgModule({
  declarations: [
    UserManagementComponent,
    UserManagementNewComponent,
    UserManagementEditComponent,
  ],
  imports: [SharedModule, StandaloneModule],
  exports: [
    UserManagementComponent,
    UserManagementNewComponent,
    UserManagementEditComponent,
  ],
})
export class UserManagementModule {}
